<p-dialog [(visible)]="visible" [modal]="true" [style]="{'min-width':minwidth, width: width }" [position]="position"
  [closable]="closable" [dismissableMask]="true" [focusOnShow]="true" [closeOnEscape]="true" [showHeader]="showHeader"
  [class]="customClass" (onHide)="onDialogHide()">
  <ng-template #container></ng-template>
</p-dialog>